// src/components/LojaRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function LojaRoute({ children }) {
  const { currentUser, userType } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (userType !== "loja") {
    return <Navigate to="/" replace />;
  }

  return children;
}
